const ServicesItem = ({icon, heading, copy, alt}) => {
  return (
    <div className="services__item">
      <div className="services__image">
        <img src={icon.src} loading="lazy" alt={alt} className="services__icon" />
      </div>

      <div className="services__text">
        <h3>{heading}</h3>
        {copy}
      </div>
    </div>
  )
}

export default ServicesItem;
